class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
  }
  handleOptions = (options) => {
    const message = this.createChatBotMessage(
      "How can I help you? Below are some possible options.",
      {
        widget: "overview",
        loading: true,
        terminateLoading: true,
        ...options
      }
    );

    this.addMessageToState(message);
  };


  handleContact = () => {
    const message = this.createChatBotMessage(
      "Call +91 6304748719 for Qshikshak Assistance.",
      {
        widget: "support",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };
  handlePricing = () => {
    const message = this.createChatBotMessage("Our pricing plans are flexible:", 
      {
        widget: "Pricing Widget",
        loading: true,
        terminateLoading: true,
        withAvatar: true
    });
    this.addMessageToState(message);
  };

  handleProductOverview = () => {
    const message = this.createChatBotMessage(
      "Qshikshak simplifies school operations by bringing everything—attendance, exams, fees, communication, and more—into one secure platform. Would you like to:",
      {
        widget: "ProductOverview",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };

  handleFeatures = () => {
    const message = this.createChatBotMessage(
      "Here are the detailed features of Qshikshak:",
      {
        widget: "Features",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };

  handleBookDemo = () => {
    const message = this.createChatBotMessage(
      "Great! To know more ,Let's book a demo for you. Please provide your contact details:",
      {
        widget: "Book a Demo",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };
handleForSchools = () => {
  const message = this.createChatBotMessage(
    "Qshikshak is built for everyone in the school ecosystem:",
    {
      widget: "ForSchool",
      loading: true,
      terminateLoading: true,
      withAvatar: true
    }
  );

  this.addMessageToState(message);
};
  handleDemoFormSubmit = (formData) => {
    const message = this.createChatBotMessage(
      `✅ Thanks, ${formData.name}! Our team will contact you at ${formData.email} soon to schedule your demo.`
    );
    this.addMessageToState(message);

    // 👉 Here you can also send `formData` to your backend API
    console.log("Demo Request:", formData);
  };


  handleThanks = () => {
    const message = this.createChatBotMessage("You're welcome, and stay safe!");

    this.addMessageToState(message);
  };

  handleAttendance = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Attendance Module*: Automates daily attendance, generates reports, and integrates with student records. Teachers and admins can track trends in real-time."
    );
    
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleTimetable = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Timetable Module*: Create, manage, and share timetables instantly with teachers, students, and parents. Auto-adjust for substitutions and holidays."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleExams = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Exams & Report Cards*: Schedule exams, enter marks, and auto-generate report cards with grading standards. Parents can view results instantly."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleFees = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Fees & Payments*: Manage fee structures, automate reminders, collect payments online, and generate financial reports securely."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleParentCommunication = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Parent Communication*: Send real-time notifications, share homework, circulars, and track parent-teacher engagement from one dashboard."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleAnalytics = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Analytics Dashboard*: Get insights into attendance trends, academic performance, and fee collections with visual reports for better decision-making."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like to see this in action?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  addMessageToState = (message) => {
    this.setState((state) => ({
      ...state,
      messages: [...state.messages, message]
    }));
  };
}

export default ActionProvider;
